import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface DeescalationSignsSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Slower breathing and more relaxed posture",
  "Quieter voice or periods of silence",
  "Reduced physical agitation (e.g., no longer pacing or clenching fists)",
  "Willingness to sit or stay in one place",
  "Avoiding eye contact or showing signs of shame or embarrassment",
  "Beginning to respond to simple, calm prompts",
  "Asking for space, a break, or water",
  "Crying that becomes softer or stops",
  "Head down or looking away, showing withdrawal rather than aggression",
  'Expressing remorse or regret ("I didn\'t mean to," "I\'m sorry")',
  "Seeking comfort or connection (e.g., asking for a trusted adult)",
  "Re-engaging in small tasks like tidying, writing, or using a calming tool",
  "Less reactive to environmental triggers or peers",
  "Sighing or deep breathing",
];

export const DeescalationSignsSection: React.FC<
  DeescalationSignsSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe observable signs of de-escalation."
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="deescalationSignsOther">
        Other:
      </label>
      <input
        type="text"
        id="deescalationSignsOther"
        name="deescalationSignsOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
